export default "__VITE_ASSET__0722f16f__"